var _excluded = ["className", "as", "size"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../font-scale-categories.css";
var Hero = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    ComponentToRender = _ref.as,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: "".concat(className, " ").concat(styles["hero-".concat(size)])
  }, props));
});
Hero.defaultProps = {
  className: '',
  as: 'div',
  size: 'sm'
};
Hero.propTypes = {
  /**
   * Font size
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  /**
   * Additional classes to apply
   */
  className: PropTypes.string,
  /**
   * Component to render
   */
  as: PropTypes.elementType
};
export default Hero;